import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  reservationSummary: {},
  yearlySummary: {},
  loading: false,
  error: null,
};

const reservationSummarySlice = createSlice({
  name: "reservationSummary",
  initialState,
  reducers: {
    fetchReservationSummarySuccess: (state, action) => {
      state.loading = false;
      state.reservationSummary = action.payload;
    },
    fetchReservationSummaryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchYearlySummarySuccess: (state, action) => {
      state.loading = false;
      state.yearlySummary = action.payload;
    },
    fetchYearlySummaryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchReservationSummarySuccess,
  fetchReservationSummaryFailure,
  fetchYearlySummarySuccess,
  fetchYearlySummaryFailure,
} = reservationSummarySlice.actions;

export default reservationSummarySlice.reducer;
